import { atom } from "recoil";

type modalInfo = {
  isOpen: boolean;
};

export const lendAndReturnModalInfoState = atom<modalInfo>({
  key: "lendAndReturnModalInfoState",
  default: {
    isOpen: false,
  }
});